module.exports = __webpack_public_path__ + "media/images/gallery/ss_on-d02504e09bf33662ddf837e28ec6731f.gif";